import React, { useState } from 'react';
import { DatePicker, Space } from 'antd';
import type { DatePickerProps, GetProps } from 'antd';

import { disabledDate, disabledDateTime } from './calendar-util';

type RangePickerProps = GetProps<typeof DatePicker.RangePicker>;

const { RangePicker } = DatePicker;

const AntDatePicker = (props: RangePickerProps) => {
  return (
    <Space direction="vertical" size={12}>
      <RangePicker
        showTime={{ format: 'HH:mm' }}
        format="YYYY-MM-DDTHH:mm:ss"
        disabledDate={disabledDate}
        disabledTime={disabledDateTime}
        {...props}
      />
    </Space>
  );
};
export default AntDatePicker;
